// extracted by mini-css-extract-plugin
export var ugcText = "UgcSubForm-module__ugcText___2ysGa";